// @flow
import * as React from 'react';
import { connect } from 'react-redux';

import 'floating-label-react/styles.css';
import FloatingLabel from 'floating-label-react';
import { GoogleReCaptcha } from 'react-google-recaptcha-v3';

import { 
  Button, 
  Card 
} from '../../ui';
import {
  setStepInnerPage
} from "../../../actions";
import authActions from '../../../actions/auth';
import { auth } from "../../../operations";

import { validateEmail } from '../../../helpers';

import iconEmail from '../../../assets/icons/icon-email.svg';
import iconAlert from '../../../assets/icons/icon-alert.svg';

class ResetPassword extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      continue: false,
      email: '',
      token: null,
      origin: ''
    };

    const { authReset } = this.props;
    authReset();
  }

  componentDidMount() {
    const { email } = this.state;
    this.checkContinueState({ continue: true }, email !== ''
      && validateEmail(email));
    this.setState({
      origin: `${window.location.href}`
    });
  }

  componentDidUpdate(prevProps, prevState) {
    const { email } = this.state;
    this.checkContinueState(prevState, email !== ''
      && validateEmail(email));
  }

  getContinueButton() {
    const { continue: isEnabled } = this.state;
    const { isLoading } = this.props;

    return (
      <Button
        block
        onClick={this.handleClick}
        disabled={!isEnabled}
        isLoading={isLoading}
      >
        Enviar contraseña
      </Button>
    );
  }

  getBackButton() {
    const { setStepInnerPage } = this.props;
    return (
      <Button
        plain
        onClick={() => { setStepInnerPage('login') }}
        className="Password-link"
      >
        Volver al login
      </Button>
    );
  }

  handleClick = () => {
    const { resetPassword } = this.props;
    const { email, token, origin } = this.state;
    resetPassword(email, origin, token);
  };

  checkContinueState(prevState, condition) {
    if (condition) {
      if (!prevState.continue) this.setState({ continue: true });
    } else if (prevState.continue) this.setState({ continue: false });
  }

  render() {
    const { result } = this.props;
    const { email, continue: continueVar } = this.state;

    return (
      <div>
        <Card.Header className="Password-firsttitle">Recuperar contraseña</Card.Header>

        <p className="Password-subtitle"> Para que te enviemos una nueva contraseña debes ingresar el correo electrónico de tu usuario</p>

        <div className="Password-inputs">
          <div className="Password-input-line">
            <img className="Password-image" alt="" src={iconEmail} />
            <FloatingLabel
              id="email"
              name="email"
              placeholder="Email"
              maxLength="50"
              type="text"
              value={email}
              onChange={(event) => { this.setState({ email: event.target.value }); }}
            />
          </div>
        </div>

        {!continueVar && email !== undefined && email !== '' && (
          <div className="Password-container">
            <img className="Password-fail" alt="" src={iconAlert} />
            <p className="Password-error">
              El email proporcionado no es válido
            </p>
          </div>
        )}
        <br />

        {result && result !== 'SUCCESS' && (
          <div className="Password-container">
            <img className="Password-fail" alt="" src={iconAlert} />
            <p className="Password-error">
              {result}
            </p>
          </div>
        )}
        <br />

        {result && result === 'SUCCESS' && (
          <p className="Password-success">
            Se ha enviado un mail de recuperación
          </p>
        )}
        <br />

        <div className="Password-buttons">
          {this.getContinueButton()}
          {this.getBackButton()}
        </div>

        <GoogleReCaptcha onVerify={token => this.setState({ token })} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.auth.isLoading,
  result: state.auth.resultMessage,
});

const mapDispatchToProps = dispatch => ({
  authReset: () => {
    dispatch(authActions.authReset());
  },
  resetPassword: (email, origin, token) => { 
    dispatch(authActions.authRequest());
    dispatch(auth.resetPassword({ email, origin, token }));
  },
  setStepInnerPage: (page) => {
    dispatch(setStepInnerPage(page));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);
